import { getErrorPayload } from '@application/common/helpers/api-helper';
import CountryApi from '@infrastructure/country-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
export const getCountriesAsync = createAsyncThunk('countries/getAll', async (_, { rejectWithValue }) => {
    try {
        const response = await CountryApi.getCountries();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
